module.exports = __webpack_public_path__ + "static/adam-miller-0c6637ee332cee684411ebf78a6d227a.png";